import { gql } from '@apollo/client';
const ADD_CONVERSATION_MEMBER = gql `
  mutation AddConversationMember($conversationId: ID!, $userId: ID!) {
    addConversationMember(conversationId: $conversationId, userId: $userId) {
      conversationmember {
        id
        user {
          id
          avatar
          username
          email
          username
        }
      }
    }
  }
`;
export default ADD_CONVERSATION_MEMBER;
